import { play, loadAnimation } from 'lottie-web/build/player/lottie_svg.min.js';

export default function () {
  const animatedIcons = document.querySelectorAll('.animated-icon');
  const wWidth = window.innerWidth;

  function doSetTimeout(i,animationText, delay) {
    setTimeout( () => {
      //console.log(`play animation${i}`);
      play(`animation${i}`);
      animationText.classList.add('in-view');
    }, i * delay);
  }


  const observerConfig = {
    rootMargin: '0px 0px -35% 0px',
    threshold: 0
  };


  if (animatedIcons) {

    for(let i = 0; i < animatedIcons.length; i++) {
      const icon = animatedIcons[i];

      // Setup Lottie
      const animationData = icon.querySelector('.animated-icon-data').innerHTML;
      const animationJSON = JSON.parse(animationData);
      const animationText = icon.nextElementSibling;
      const thisAnim = loadAnimation({
        animationData: animationJSON,
        container: icon,
        renderer: 'svg',
        loop: false,
        name: `animation${i}`,
        autoplay: false,
      });

      // thisAnim.addEventListener('loopComplete', yo(animationText));


      const observer = new IntersectionObserver( function(entries) {
        entries.forEach(function(entry) {
          if (entry.intersectionRatio > 0) {
            if(wWidth > 767) {
              doSetTimeout(i,animationText, 500);
            } else {
              doSetTimeout(i,animationText, 0);
            }
            observer.unobserve(entry.target);
          }
        });
      }, observerConfig);

      observer.observe(icon);

    }
  }
}
